import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  Pagination,
  Box,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import dayjs from "dayjs";
import GetValidityChip from "./GetValidityChip";
import AgreementActions from "./AgreementActions";

const AgreementTable = ({
  agreements = [],
  page,
  totalCount,
  onPageChange,
  setSelectedAgreementId,
  setTabIndex,
  showActions,
  onShow,
  onEdit,
  onEditIndicators,
  onReport,
  onUpdateStatus
}) => {
  const totalPages = Math.ceil(totalCount / 10);
  const perPage = 10;

  const publicAgreement = (id) => {
    setSelectedAgreementId(id);
    setTabIndex(1);
  };

  return (
    <TableContainer component={Paper} sx={{ width: "100%", mx: "auto", mt: 3 }}>
      {(totalPages > 0) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
            mx: "auto",
          }}
        >
          <Typography variant="body2" sx={{ ml: 1 }}>
            Mostrando {(page - 1) * perPage + 1}–
            {Math.min(page * perPage, totalCount)} de {totalCount} convenios
          </Typography>

          <Pagination
            count={Math.ceil(totalCount / perPage)}
            page={page}
            onChange={onPageChange}
            color="primary"
          />
        </Box>
      )}
      <Table>
        <TableHead>
          <TableRow
            hover
            sx={{ "&:nth-of-type(odd)": { backgroundColor: "#f9f9f9" } }}
          >
            <TableCell>Estado</TableCell>
            <TableCell>N° de orden</TableCell>
            <TableCell>Objetivo</TableCell>
            <TableCell>Tipo</TableCell>
            <TableCell>Institución</TableCell>
            <TableCell>Fecha de suscripción</TableCell>
            <TableCell>Vigencia</TableCell>
            <TableCell>Acciones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {agreements.length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} align="center">
                No se encontraron convenios.
              </TableCell>
            </TableRow>
          ) : (
            agreements.map((agreement, index) => (
              <TableRow
                key={agreement.id}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#fafafa" : "#fff",
                }}
              >
                <TableCell>
                  <GetValidityChip status={agreement.status} />
                </TableCell>
                <TableCell>{agreement.order_number}</TableCell>
                <TableCell>{agreement.objective}</TableCell>
                <TableCell>{agreement.agreement_type}</TableCell>
                <TableCell>{agreement.entity}</TableCell>
                <TableCell>
                  {agreement.suscription_date
                    ? dayjs(agreement.suscription_date).format("DD/MM/YYYY")
                    : "Sin fecha"}
                </TableCell>
                <TableCell>
                  {dayjs(agreement.effective_date).format("DD/MM/YYYY")}
                </TableCell>
                <TableCell>
                  {showActions ? (
                      <AgreementActions
                        agreement={agreement}
                        onShow={onShow}
                        onEdit={onEdit}
                        onEditIndicators={onEditIndicators}
                        onReport={onReport}
                        onUpdateStatus={onUpdateStatus}
                      />
                  ) : (
                    <Tooltip title="Ver detalles">
                      <IconButton
                        onClick={() => publicAgreement(agreement.id)}
                        color="primary"
                      >
                        <ArrowForwardIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default AgreementTable;
